var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { DocumentableType, StudentDocumentTemplate } from '@/models/StudentDocumentTemplate';
import ErrorHandler from '@/support/ErrorHandler';
import PlanTemplateRow from '@/components/PlanTemplateRow/PlanTemplateRow';
let CreatePlanTemplateDialog = class CreatePlanTemplateDialog extends Vue {
    constructor() {
        // #endregion
        super(...arguments);
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isAddingStep = false;
        this.payload = {
            name: '',
            blocks: [],
        };
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #region Getters & Setters
    get editorOptions() {
        return {
            placeholder: this.$t('subject.dialog.achievedNote.placeholder'),
        };
    }
    closeDialog() {
        this.$emit('input', false);
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.appendLearningObjective();
    }
    // #endregion
    // #region Class methods
    onRemoveObjective(index) {
        this.isAddingStep = true;
        if (!this.payload.blocks) {
            return;
        }
        this.payload.blocks.splice(index, 1);
        this.isAddingStep = false;
    }
    appendBlockByType(type = 'text') {
        const newBlock = this.createLearningObjective(type);
        this.appendLearningObjective(newBlock);
    }
    appendLearningObjective(learningObjective) {
        this.isAddingStep = true;
        if (!learningObjective) {
            learningObjective = this.createLearningObjective();
        }
        this.payload.blocks.push(learningObjective);
        this.isAddingStep = false;
    }
    createLearningObjective(type = 'text') {
        return {
            content: '',
            title: type === 'simple-text' ? '' : '',
            sort: 0,
            type,
        };
    }
    // #endregion
    // #region Async methods
    async createPlanTemplate() {
        try {
            await new StudentDocumentTemplate().create(this.payload);
            this.$emit('created');
            this.closeDialog();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters
    get documentableTypes() {
        return [
            {
                text: this.$tc('group_text'),
                value: DocumentableType.GROUP,
            },
            {
                text: this.$tc('student_text'),
                value: DocumentableType.USER,
            },
            {
                text: this.$tc('Goal set'),
                value: DocumentableType.PROJECT,
            },
        ];
    }
};
CreatePlanTemplateDialog = __decorate([
    Component({
        components: {
            SelectFilter,
            PlanTemplateRow,
        },
    })
], CreatePlanTemplateDialog);
export default CreatePlanTemplateDialog;
